<template>
  <div>
    <button class="btn" :class="classes" title="Save product" @click="bookmarkThisProduct">
      <i v-if="loading" class="fas fa-spinner spin" />
      <i v-else-if="disabled" class="fas fa-check" />
      <b-spinner small v-if="isSavingOrDeletingBookmark"></b-spinner>
      <b-icon
        :icon="isProductAlreadyBookmarked ? 'bookmark-check' : 'bookmark-fill'"
        v-else
        v-b-tooltip.hover
        :title="isProductAlreadyBookmarked ? 'unbookmark' : 'bookmark'"
      ></b-icon>
    </button>
  </div>
</template>

<script>
import { addBookmark, deleteBookmark, getBuyer } from "../../api";
import { bookmarkMixin } from "./../../mixins/bookmarkMixin";

export default {
  name: "BookmarkButton",
  props: {
    btnClasses: {
      default: () => ["btn-sm", "btn-primary"],
      type: Array
    },
    productId: {
      required: true,
      type: Number | String
    }
  },
  mixins: [bookmarkMixin],
  data() {
    return {
      open: false,
      loading: false
    };
  },
  mounted() {
    this.getBookmarkList();
  },
  methods: {
    async bookmarkThisProduct() {
      if (!this.$isLoggedIn) {
        localStorage.setItem('login-redirect', 'bookmark-product');
        this.$bvModal.show("login-as");

      } else {
        this.saveDeleteBookmark(this.productId);
      }
    },
    authenticated() {
      this.loading = true;
      this.open = false;
      this.addBookmark();
    },
    async addBookmark() {
      if (this.disabled) {
        this.loading = true;
        await deleteBookmark(this.bookmark.id);
      } else {
        await addBookmark(this.productId, this.$store.getters.buyer.id);
      }
      const buyer = await getBuyer(this.$store.getters.buyer.id);
      this.$store.dispatch("setBuyer", buyer);
      this.loading = false;
    }
  },
  computed: {
    bookmark() {
      if (this.$store.getters.buyer && this.$store.getters.buyer.bookmarks)
        return this.$store.getters.buyer.bookmarks.find(
          ({ product_id }) => product_id === this.productId
        );
      else return null;
    },
    disabled() {
      return !!this.bookmark;
    },
    classes() {
      return [...[this.disabled ? "disabled" : ""], ...this.btnClasses];
    }
  }
};
</script>

<style scoped lang="scss">
.btn {
  // color: #fff !important;

  &:disabled {
    opacity: 0.3;
  }
}
</style>
